import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ec689b5e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"max-width":"150px","font-size":"14px"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "small_img",
  src: "https://static-s.theckb.com/BusinessMarket/Client/JP.png",
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "small_img",
  src: "https://static-s.theckb.com/BusinessMarket/Client/CN.png",
  alt: ""
}, null, -1))

import { t } from '@/plugins/i18n';


export default /*#__PURE__*/_defineComponent({
  props: {
    disabled: { type: Boolean, required: true },
    all: { type: Number, required: true },
    jp: { type: Number, required: true },
    cn: { type: Number, required: true },
    unit: { type: String, required: false }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createBlock(_component_el_tooltip, {
    disabled: __props.disabled,
    effect: "light",
    placement: "top",
    "popper-class": "tool-tip-no-border"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("p", null, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(__props.jp ?? 0), 1)
        ]),
        _createElementVNode("p", null, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(__props.cn ?? 0), 1)
        ])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("span", null, _toDisplayString(__props.all ?? 0) + _toDisplayString(__props.unit), 1)
    ]),
    _: 1
  }, 8, ["disabled"]))
}
}

})